import { useDispatch, useSelector } from "react-redux";

import type { CrmColumnItem } from "app/pages/sales-intelligence/sub-modules/management/types";

import CrmEnrichmentFieldsMappingWizardStep from "../../../components/wizard/CrmEnrichmentFieldsMappingWizardStep";
import { useCrmEnrichmentContext } from "../../../contexts/CrmEnrichmentContext";
import { addMapping, removeMapping, updateMapping } from "../../../store/action-creators";
import { selectMappings, selectSelectedJobObject, selectSelectedJobType } from "../../../store/selectors";
import type { CrmEnrichmentJobObject, EnrichmentJobMappingDTO } from "../../../types/types";

type Props = {
    columns: readonly CrmColumnItem[];
    isColumnsLoading: boolean;
};

const CrmEnrichmentFieldsMappingWizardStepContainer = ({ columns, isColumnsLoading }: Props) => {
    const dispatch = useDispatch();
    const { crmProvider } = useCrmEnrichmentContext();

    const mappings = useSelector(selectMappings);
    const selectedJobObject = useSelector(selectSelectedJobObject);
    const selectedJobType = useSelector(selectSelectedJobType);

    const handleAddMapping = (mapping: EnrichmentJobMappingDTO): void => {
        dispatch(addMapping(mapping));
    };

    const handleRemoveMapping = (index: number): void => {
        dispatch(removeMapping(index));
    };

    const handleUpdateMapping = (index: number, changes: Partial<EnrichmentJobMappingDTO>): void => {
        dispatch(updateMapping({ index, changes }));
    };

    return (
        <CrmEnrichmentFieldsMappingWizardStep
            crmProvider={crmProvider}
            enrichmentObject={(selectedJobObject || "company") as CrmEnrichmentJobObject}
            jobType={selectedJobType}
            mappings={mappings}
            columns={columns}
            isColumnsLoading={isColumnsLoading}
            onAddMapping={handleAddMapping}
            onRemoveMapping={handleRemoveMapping}
            onUpdateMapping={handleUpdateMapping}
        />
    );
};

export default CrmEnrichmentFieldsMappingWizardStepContainer;
